import { CircularProgress, Dialog } from "@mui/material";
import Loader from "../Loader";

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  title,
  description,
  confirmButtonLabel,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <div className="bg-white p-6">
        <h2 className="font-semibold text-xl mb-3">{title}</h2>
        <p className="text-neutral mb-5">{description}</p>
        <div className="flex items-center justify-center space-x-5">
          <button
            className="bg-neutral-200 rounded-md px-4 py-1.5 text-black disabled:opacity-50"
            onClick={() => setIsOpen(false)}
            disabled={isLoading}
          >
            Cancel
          </button>

          <button
            className="bg-cyan-800 rounded-md px-4 py-1.5 text-white disabled:opacity-50"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {confirmButtonLabel}
          </button>
        </div>
        {isLoading && (
          <div className="mt-4 flex justify-center text-center space-x-2 items-center">
            <CircularProgress size={16} />
            <p>Loading...</p>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
